const mutations = {
  changeCurrency(state, val) {
    state.currency = val
  },
}
export default mutations
